import { Logger } from "neo-common";
import { Resource } from "./Resource";

/**
 * The SndResource is used for holding songs from preloading. Supported all types of songs.
 * @class SndResource
 * @extends Resource
 */
export class SndResource extends Resource {
    static Sounds: { [id: string]: AudioBuffer } = {};

    /**
     * Return song by id.
     * @method getSongById
     * @param id id of song in files.xml
     * @return AudioBuffer
     */
    static getSongById(id: string): AudioBuffer {
        if (this.Sounds != null) {
            return this.Sounds[id];
        } else {
            if (DEBUG) {
                this.log("ERROR no sounds");
            }
        }
        if (DEBUG) {
            this.log("ERROR no song: " + id);
        }
        return null;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("SndResource", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Resources/SndResource.ts
 **/